const game = {
  // 全部游戏
  myGames: `/pcApi/v1/homeapi/gameindex/myGames`,
  // 删除游戏
  delLatelyGame: `/pcApi/v1/homeapi/gameindex/delLatelyGame`,
  // 游戏详情
  // gameInfo: `/pcApi/v1/homeapi/gameindex/gameInfo`,
  // java接口
  // 游戏详情
  getGameInfo: `/authApi/box/v1/getGameInfo`,
  // 游戏超时时间 java
  getPCDetailConfig: `/authApi/box/v2/getPcDetailConfig`,
  // 详情任务列表 java
  getTaskListVo: `/authApi/box/v1/task/getTaskListVo`,
  // 详情轮播 java
  getPublicityList: `/authApi/box/v1/getPublicityList`,
  // 游戏礼包
  gameGift: `/pcApi/v2/homeapi/FindGame/gift`,
  // 游戏礼包 java
  gameGiftJava: `/authApi/box/v1/getGift`,
  // 游戏礼包SVIP
  gameGiftSvip: `/userApi/v3/Svip/games`,
  // 游戏礼包码
  getGameGiftCode: `/pcApi/v1/homeapi/Gameindex/getGameGiftCode`,
  // 同厂推荐
  firmRecommend: `/pcApi/v1/homeapi/gameindex/firmRecommend`,
  // 直接启动游戏
  EnterGame: `/pcApi/v1/homeapi/gameindex/EnterGame`,
  // 启动游戏登录器
  EnterGameClient: `/pcApi/v1/homeapi/gameindex/EnterGameClient`,
  // 角色试玩登录游戏
  demoaccountlogin: `/pcApi/v1/homeapi/Gameindex/demoaccountlogin`,
  // 批量获取游戏信息 ----- 刘阳
  getGamesInfo: `/forumApi/v1/Game/getGamesInfo`,
  // 直播埋点-记录启动游戏场景
  recordEnterGameScene: `/pcApi/v1/homeapi/Gameindex/recordEnterGameScene`,
  // 启动游戏
  EnterGameV1: '/authApi/user/gameIndex/enterGame',
  // 获取客服配置
  configCustomerService: '/userApi/v1/CustomerService/config',
  // 今日开服列表
  todayOpen: '/authApi/box/v1/getTodayOpen',
  // 获取游戏客服入口相关信息
  entrance: '/authApi/user/v1/customer/service/entrance',
  // 点击客服入口拉起客服会话
  session: '/authApi/user/v1/customer/service/session',
  // 首页检测云手机在玩提示 -- 苏昕
  tipPoint: '/authApi/cloud/v1/tip/point',
  // 查询投票进行中活动游戏得票数
  queryGameVote: '/authApi/activity/a1014/v1/queryGameVote',
  // 游戏获奖信息
  listGameAwards: '/authApi/box/game/listGameAwards',
  // 投票阶段查询
  queryVoteStageInfo: '/authApi/activity/a1014/home/v1/voteStageInfo',
  // 投票游戏奖项名称查询
  queryAwardName: '/authApi/activity/a1014/v1/queryAwardName'
};

export default game;
